import { render, staticRenderFns } from "./AllMessage.vue?vue&type=template&id=e47f004e&"
import script from "./AllMessage.vue?vue&type=script&lang=js&"
export * from "./AllMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports